module.exports = __webpack_public_path__ + "img/dotted-circle-216.526d3571.svg";